export default __webpack_public_path__ + "static/media/user-plus-dark.b53f7df2.svg";